import styled from "styled-components";

export const TotalTableContainer = styled.div`
  top: 80px;

  @media (max-width: 991px) {
    top: 60px;
  }
`;
